
export const ValidateFinancialDocInput = (financialDoc, _createErrorMessage) => {
  if (!financialDoc) {
    _createErrorMessage("72");
    return false;
  }

  return true;
};
